var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(" "+_vm._s(_vm.$t("imageMap.fontSelectorTitle"))+" ")]),_c('v-divider',{staticClass:"pa-2"}),_c('div',{key:_vm.valKey,staticClass:"d-flex justify-space-between align-center"},_vm._l((_vm.sizes),function(s,i){return _c('div',{key:i,class:`font-chip d-flex justify-center align-center ${
        _vm.size === s ? 'primary white--text' : ''
      }`,style:(`font-size: ${s}px; font-weight: bolder;`),on:{"click":() => (_vm.size = s)}},[_c('span',[_vm._v("EX")])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }